module.exports = __webpack_public_path__ + "static/media/mom.b77b2bca.jpg";